import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PortalLayout from "@/components/portal/PortalLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PortalProfile() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "", mobile: user?.mobile || "", cnic: user?.cnic || "",
    address: user?.address || "", city: user?.city || "",
  });
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/auth/profile", form);
      await refreshUser();
      toast.success("Profile updated");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <PortalLayout title="My Profile">
      <div className="grid gap-6 lg:grid-cols-3">
        <div className="rounded-xl border border-border bg-card p-6">
          <div className="grid h-16 w-16 place-items-center rounded-full bg-primary font-display text-2xl font-extrabold text-primary-foreground">{(user?.name || "C")[0].toUpperCase()}</div>
          <p className="mt-4 font-display text-lg font-semibold">{user?.name}</p>
          <p className="text-sm text-muted-foreground">{user?.email}</p>
          <p className="mt-2 font-mono text-xs text-muted-foreground">{user?.customer_no}</p>
        </div>
        <form onSubmit={save} className="rounded-xl border border-border bg-card p-6 lg:col-span-2 grid gap-4 sm:grid-cols-2">
          <div><Label>Full Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="profile-name" /></div>
          <div><Label>Mobile</Label><Input value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} data-testid="profile-mobile" /></div>
          <div><Label>CNIC</Label><Input value={form.cnic} onChange={(e) => setForm({ ...form, cnic: e.target.value })} data-testid="profile-cnic" /></div>
          <div><Label>City</Label><Input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} data-testid="profile-city" /></div>
          <div className="sm:col-span-2"><Label>Address</Label><Input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} data-testid="profile-address" /></div>
          <Button type="submit" disabled={busy} className="rounded-full sm:col-span-2" data-testid="save-profile-btn">{busy ? "Saving..." : "Save Changes"}</Button>
        </form>
      </div>
    </PortalLayout>
  );
}
